import RegressionLineExtension from './regression-line-extension';
import { componentFactory } from '../../../fc-core/src/lib';
import { isValidDataset, hasRegressionLine } from './utility-functions';
export default {
  extension: function extension(a) {
    a.addEventListener('instantiated', function (a) {
      var b = a.sender;
      isValidDataset(b) && b.registerFactory('regression', function (a) {
        var b = a.getFromEnv('chart'),
            c = b.getFromEnv('dataSource').chart,
            d = a.config.JSONData;
        componentFactory(a, RegressionLineExtension, 'regression', +hasRegressionLine(c, d), [a]);
      });
    });
  },
  name: 'Regression',
  type: 'extension',
  requiresFusionCharts: !0
};